import Container from "../../../components/container";
import line from "../../../assets/images/section3_line.svg";
import Button from "../../../components/buttons/button";

export default function Section3() {
   return (<section className="mt-[66px] mb-[80px]"
   >
      <Container className="!px-[30px] md:!px-0">
         <div className="flex flex-col items-center gap-[40px] lg:gap-[30px] lg:flex-row lg:items-start" >
            <div className="max-w-[370px] w-full flex flex-col">
               <h3 className="font-bold text-[24px] leading-[40px] text-[#003A75] mb-[9px] text-center">Games</h3>
               <img src={line} alt="line" className="w-full h-[9px]" />
               <p className="text-[15px] leading-[25px] text-[#00000] pt-[26px]">We create engaging experiences across casual, mid-core, and family-friendly genres: puzzles, runners, arcade, strategy, simulation, and creativity apps. Expect tight controls, smooth performance on a wide device range, and satisfying progression systems that respect players’ time.</p>
               <p className="text-[15px] leading-[25px] text-[#00000] pt-[30px]">
                  — Polished gameplay loops and fair economies<br />
                  — Lightweight builds and fast cold starts<br />
                  — Localized content and store listings<br />
                  — Accessibility and low-end device support
               </p>
               <div className="flex flex-col mt-[35px] gap-[20px]">
                  <Button
                     label="Explore on Google Play"
                     variant="primary"
                     className="w-full"
                     onClick={() => { }}
                  />
                  <Button
                     label="Explore on the App Store"
                     variant="primary"
                     className="w-full"
                     onClick={() => { }}
                  />
               </div>
            </div>
            <div className="max-w-[370px] w-full flex flex-col">
               <h3 className="font-bold text-[24px] leading-[40px] text-[#003A75] mb-[9px] text-center">Cloud & AI Apps</h3>
               <img src={line} alt="line" className="w-full h-[9px]" />
               <p className="text-[15px] leading-[25px] text-[#00000] pt-[26px]">We ship cloud applications where AI makes the difference—image and media tools, productivity utilities, creators’ toolkits, and smart automation.</p>
               <p className="text-[15px] leading-[25px] text-[#00000] pt-[30px]">
                  — Modern AI inference (on-device or cloud)<br />
                  — Secure APIs and rate-limited endpoints<br />
                  — Account systems, subscriptions, and billing<br />
                  — Usage analytics and churn reduction flows<br />
               </p>
            </div>
            <div className="max-w-[370px] w-full flex flex-col">
               <h3 className="font-bold text-[24px] leading-[40px] text-[#003A75] mb-[9px] text-center">Services for partners</h3>
               <img src={line} alt="line" className="w-full h-[9px]" />
               <div className="flex flex-col mt-[26px] gap-[20px] w-full">
                  <p className="text-[15px] leading-[25px]"><span className="text-[#003A75] font-bold">Full-cycle development</span>  - Concept, GDD, prototypes, production, soft launch, global launch.</p>
                  <p className="text-[15px] leading-[25px]"><span className="text-[#003A75] font-bold">Porting & SDKs</span> – Game engines, ads, attribution, analytics, payments, achievements, leaderboards.</p>
                  <p className="text-[15px] leading-[25px]"><span className="text-[#003A75] font-bold">Publishing</span> – Store assets, ASO, localization, compliance, age ratings, review support.</p>
                  <p className="text-[15px] leading-[25px]"><span className="text-[#003A75] font-bold">LiveOps</span> – Seasonal events, offers, remote configs, content drops, player support, and community.</p>
                  <p className="text-[15px] leading-[25px]"><span className="text-[#003A75] font-bold">Quality & Security</span> – Functional, device matrix, soak, and regression testing; secure pipelines.</p>
               </div>

               {/* Full-cycle development – Concept, GDD, prototypes, production, soft launch, global launch. 
Porting & SDKs – Game engines, ads, attribution, analytics, payments, achievements, leaderboards. 
               Publishing – Store assets, ASO, localization, compliance, age ratings, review support. 
LiveOps – Seasonal events, offers, remote configs, content drops, player support, and community. 
               Quality & Security – Functional, device matrix, soak, and regression testing; secure pipelines. */}
            </div>
                        </div>
      </Container>
                  </section>
   );
}